module.exports = __webpack_public_path__ + "img/ea4af01.png";